export class OrderModel {
    entity: string;
    direction: string;
}